/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakMilestone } from './StreakMilestone';
import {
    StreakMilestoneFromJSON,
    StreakMilestoneFromJSONTyped,
    StreakMilestoneToJSON,
    StreakMilestoneToJSONTyped,
} from './StreakMilestone';
import type { StreakPerWindowEscalation } from './StreakPerWindowEscalation';
import {
    StreakPerWindowEscalationFromJSON,
    StreakPerWindowEscalationFromJSONTyped,
    StreakPerWindowEscalationToJSON,
    StreakPerWindowEscalationToJSONTyped,
} from './StreakPerWindowEscalation';
import type { StreakActiveMultiplier } from './StreakActiveMultiplier';
import {
    StreakActiveMultiplierFromJSON,
    StreakActiveMultiplierFromJSONTyped,
    StreakActiveMultiplierToJSON,
    StreakActiveMultiplierToJSONTyped,
} from './StreakActiveMultiplier';
import type { StreakForgiveness } from './StreakForgiveness';
import {
    StreakForgivenessFromJSON,
    StreakForgivenessFromJSONTyped,
    StreakForgivenessToJSON,
    StreakForgivenessToJSONTyped,
} from './StreakForgiveness';
import type { StreakCriteriaOperator } from './StreakCriteriaOperator';
import {
    StreakCriteriaOperatorFromJSON,
    StreakCriteriaOperatorFromJSONTyped,
    StreakCriteriaOperatorToJSON,
    StreakCriteriaOperatorToJSONTyped,
} from './StreakCriteriaOperator';
import type { StreakScope } from './StreakScope';
import {
    StreakScopeFromJSON,
    StreakScopeFromJSONTyped,
    StreakScopeToJSON,
    StreakScopeToJSONTyped,
} from './StreakScope';
import type { StreakCadence } from './StreakCadence';
import {
    StreakCadenceFromJSON,
    StreakCadenceFromJSONTyped,
    StreakCadenceToJSON,
    StreakCadenceToJSONTyped,
} from './StreakCadence';
import type { StreakCriteria } from './StreakCriteria';
import {
    StreakCriteriaFromJSON,
    StreakCriteriaFromJSONTyped,
    StreakCriteriaToJSON,
    StreakCriteriaToJSONTyped,
} from './StreakCriteria';
import type { PrerequisiteResponse } from './PrerequisiteResponse';
import {
    PrerequisiteResponseFromJSON,
    PrerequisiteResponseFromJSONTyped,
    PrerequisiteResponseToJSON,
    PrerequisiteResponseToJSONTyped,
} from './PrerequisiteResponse';
import type { StreakOutcome } from './StreakOutcome';
import {
    StreakOutcomeFromJSON,
    StreakOutcomeFromJSONTyped,
    StreakOutcomeToJSON,
    StreakOutcomeToJSONTyped,
} from './StreakOutcome';

/**
 * 
 * @export
 * @interface StreakConfigResponse
 */
export interface StreakConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof StreakConfigResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof StreakConfigResponse
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof StreakConfigResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StreakConfigResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StreakConfigResponse
     */
    description?: string;
    /**
     * 
     * @type {StreakCadence}
     * @memberof StreakConfigResponse
     */
    cadence: StreakCadence;
    /**
     * 
     * @type {number}
     * @memberof StreakConfigResponse
     */
    customCadenceHours?: number;
    /**
     * 
     * @type {number}
     * @memberof StreakConfigResponse
     */
    windowStartHour?: number;
    /**
     * 
     * @type {string}
     * @memberof StreakConfigResponse
     */
    timezone?: string;
    /**
     * 
     * @type {Array<StreakCriteria>}
     * @memberof StreakConfigResponse
     */
    criteria?: Array<StreakCriteria>;
    /**
     * 
     * @type {StreakCriteriaOperator}
     * @memberof StreakConfigResponse
     */
    criteriaOperator?: StreakCriteriaOperator;
    /**
     * 
     * @type {number}
     * @memberof StreakConfigResponse
     */
    targetStreak?: number;
    /**
     * 
     * @type {StreakForgiveness}
     * @memberof StreakConfigResponse
     */
    forgiveness?: StreakForgiveness;
    /**
     * 
     * @type {Array<StreakMilestone>}
     * @memberof StreakConfigResponse
     */
    milestones?: Array<StreakMilestone>;
    /**
     * 
     * @type {Array<StreakOutcome>}
     * @memberof StreakConfigResponse
     */
    perWindowOutcomes?: Array<StreakOutcome>;
    /**
     * 
     * @type {StreakPerWindowEscalation}
     * @memberof StreakConfigResponse
     */
    perWindowEscalation?: StreakPerWindowEscalation;
    /**
     * 
     * @type {StreakActiveMultiplier}
     * @memberof StreakConfigResponse
     */
    activeMultiplier?: StreakActiveMultiplier;
    /**
     * 
     * @type {StreakScope}
     * @memberof StreakConfigResponse
     */
    scope: StreakScope;
    /**
     * 
     * @type {string}
     * @memberof StreakConfigResponse
     */
    surfaceId?: string;
    /**
     * 
     * @type {string}
     * @memberof StreakConfigResponse
     */
    brandId?: string;
    /**
     * 
     * @type {string}
     * @memberof StreakConfigResponse
     */
    competitionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StreakConfigResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof StreakConfigResponse
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof StreakConfigResponse
     */
    endAt?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StreakConfigResponse
     */
    isPublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StreakConfigResponse
     */
    showOnLeaderboard?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StreakConfigResponse
     */
    isShared?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StreakConfigResponse
     */
    sharedRequiredParticipants?: number;
    /**
     * Time-limited competitive streak ranked by streak length at endAt
     * @type {boolean}
     * @memberof StreakConfigResponse
     */
    isChallenge?: boolean;
    /**
     * Eligibility gates — all must be satisfied before a user can join the streak.
     * @type {Array<PrerequisiteResponse>}
     * @memberof StreakConfigResponse
     */
    prerequisites?: Array<PrerequisiteResponse>;
    /**
     * A STEP_ICONS key (e.g. "FaFire") — the shared icon vocabulary used by the journey and quest milestone editors.
     * @type {string}
     * @memberof StreakConfigResponse
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof StreakConfigResponse
     */
    createdBy?: string;
}



/**
 * Check if a given object implements the StreakConfigResponse interface.
 */
export function instanceOfStreakConfigResponse(value: object): value is StreakConfigResponse {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('cadence' in value) || value['cadence'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function StreakConfigResponseFromJSON(json: any): StreakConfigResponse {
    return StreakConfigResponseFromJSONTyped(json, false);
}

export function StreakConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'cadence': StreakCadenceFromJSON(json['cadence']),
        'customCadenceHours': json['customCadenceHours'] == null ? undefined : json['customCadenceHours'],
        'windowStartHour': json['windowStartHour'] == null ? undefined : json['windowStartHour'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'criteria': json['criteria'] == null ? undefined : ((json['criteria'] as Array<any>).map(StreakCriteriaFromJSON)),
        'criteriaOperator': json['criteriaOperator'] == null ? undefined : StreakCriteriaOperatorFromJSON(json['criteriaOperator']),
        'targetStreak': json['targetStreak'] == null ? undefined : json['targetStreak'],
        'forgiveness': json['forgiveness'] == null ? undefined : StreakForgivenessFromJSON(json['forgiveness']),
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(StreakMilestoneFromJSON)),
        'perWindowOutcomes': json['perWindowOutcomes'] == null ? undefined : ((json['perWindowOutcomes'] as Array<any>).map(StreakOutcomeFromJSON)),
        'perWindowEscalation': json['perWindowEscalation'] == null ? undefined : StreakPerWindowEscalationFromJSON(json['perWindowEscalation']),
        'activeMultiplier': json['activeMultiplier'] == null ? undefined : StreakActiveMultiplierFromJSON(json['activeMultiplier']),
        'scope': StreakScopeFromJSON(json['scope']),
        'surfaceId': json['surfaceId'] == null ? undefined : json['surfaceId'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'isActive': json['isActive'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'isPublic': json['isPublic'] == null ? undefined : json['isPublic'],
        'showOnLeaderboard': json['showOnLeaderboard'] == null ? undefined : json['showOnLeaderboard'],
        'isShared': json['isShared'] == null ? undefined : json['isShared'],
        'sharedRequiredParticipants': json['sharedRequiredParticipants'] == null ? undefined : json['sharedRequiredParticipants'],
        'isChallenge': json['isChallenge'] == null ? undefined : json['isChallenge'],
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteResponseFromJSON)),
        'icon': json['icon'] == null ? undefined : json['icon'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function StreakConfigResponseToJSON(json: any): StreakConfigResponse {
    return StreakConfigResponseToJSONTyped(json, false);
}

export function StreakConfigResponseToJSONTyped(value?: StreakConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'cadence': StreakCadenceToJSON(value['cadence']),
        'customCadenceHours': value['customCadenceHours'],
        'windowStartHour': value['windowStartHour'],
        'timezone': value['timezone'],
        'criteria': value['criteria'] == null ? undefined : ((value['criteria'] as Array<any>).map(StreakCriteriaToJSON)),
        'criteriaOperator': StreakCriteriaOperatorToJSON(value['criteriaOperator']),
        'targetStreak': value['targetStreak'],
        'forgiveness': StreakForgivenessToJSON(value['forgiveness']),
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(StreakMilestoneToJSON)),
        'perWindowOutcomes': value['perWindowOutcomes'] == null ? undefined : ((value['perWindowOutcomes'] as Array<any>).map(StreakOutcomeToJSON)),
        'perWindowEscalation': StreakPerWindowEscalationToJSON(value['perWindowEscalation']),
        'activeMultiplier': StreakActiveMultiplierToJSON(value['activeMultiplier']),
        'scope': StreakScopeToJSON(value['scope']),
        'surfaceId': value['surfaceId'],
        'brandId': value['brandId'],
        'competitionId': value['competitionId'],
        'isActive': value['isActive'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'isPublic': value['isPublic'],
        'showOnLeaderboard': value['showOnLeaderboard'],
        'isShared': value['isShared'],
        'sharedRequiredParticipants': value['sharedRequiredParticipants'],
        'isChallenge': value['isChallenge'],
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteResponseToJSON)),
        'icon': value['icon'],
        'createdBy': value['createdBy'],
    };
}

